<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section epub:type="toc">
<p class="sp"> </p>
<hgroup>
<h1 class="FMH"><span epub:type="pagebreak" id="pg_v" title="v"><samp class="SANS-MetaBook-Roman-11">CONTENTS</samp></span></h1>
</hgroup>
<ol class="toc">
<li class="CFMH" id="c_ter"><a href="#/xhtml/terminology#ter"><span class="list-text1">A Note on Terminology</span></a></li>
<li class="CCT" id="c_int"><a href="#/xhtml/introduction#int"><span class="list-text">Introduction</span></a></li>
<li class="CCT" id="c_ch1"><a href="#/xhtml/chapter_1#ch1"><span class="list-num">1</span> <span class="list-text">The Storyteller and the Sultan of France</span></a></li>
<li class="CCT" id="c_ch2"><span href="#/xhtml/chapter_2#ch2" title="Link target outside of Sample"><span class="list-num">2</span> <span class="list-text">Marvellous Thieves</span></span></li>
<li class="CCT" id="c_ch3"><span href="#/xhtml/chapter_3#ch3" title="Link target outside of Sample"><span class="list-num">3</span> <span class="list-text">The Empire of English</span></span></li>
<li class="CCT" id="c_ch4"><span href="#/xhtml/chapter_4#ch4" title="Link target outside of Sample"><span class="list-num">4</span> <span class="list-text">The Magician’s Interpreter</span></span></li>
<li class="CCT" id="c_ch5"><span href="#/xhtml/chapter_5#ch5" title="Link target outside of Sample"><span class="list-num">5</span> <span class="list-text">The Wiles of Women</span></span></li>
<li class="CCT" id="c_ch6"><span href="#/xhtml/chapter_6#ch6" title="Link target outside of Sample"><span class="list-num">6</span> <span class="list-text">Stealing with Style</span></span></li>
<li class="CCT" id="c_ch7"><span href="#/xhtml/chapter_7#ch7" title="Link target outside of Sample"><span class="list-num">7</span> <span class="list-text">The False Caliph</span></span></li>
<li class="CBMH1" id="c_not"><span href="#/xhtml/notes#not" title="Link target outside of Sample"><span class="list-text1">Notes</span></span></li>
<li class="CBMH" id="c_ack"><span href="#/xhtml/acknowledgments#ack" title="Link target outside of Sample"><span class="list-text1">Acknowledgments</span></span></li>
<li class="CBMH" id="c_ill"><span href="#/xhtml/illustration#ill" title="Link target outside of Sample"><span class="list-text1">Illustration Credits</span></span></li>
<li class="CBMH" id="c_ind"><span href="#/xhtml/index#ind" title="Link target outside of Sample"><span class="list-text1">Index</span></span></li>
</ol>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?5e6a54ff